export default __webpack_public_path__ + "static/media/srednje_p.596fb686.png";